<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-left">
  <li
    class="nav-item"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    *ngIf="hasReportingAccess()"
  >
    <a
      id="navReportingItem"
      (click)="storeResetLvLGod('MyCoverage')"
      href="javascript:;"
      class="nav-link waves-effect waves-dark"
      tooltipPosition="bottom"
    >
      <i class="fa-solid fa-layer-group font-18 mr-2"></i
      ><span class="font-18 force-pointer" *ngIf="visibleLabels">Context</span>
    </a>
  </li>

  <li class="nav-item">
    <a
      id="navHomeItem"
      class="nav-link waves-effect waves-dark"
      (click)="storeResetLvLGod('Home')"
      tooltipPosition="bottom"
    >
      <i class="pi pi-search font-18 mr-2"></i>
      <span class="font-18 force-pointer" *ngIf="visibleLabels">Search</span>
    </a>
  </li>

  <li class="nav-item">
    <p-overlayPanel #opMore>
      <ng-template pTemplate>
        <div class="dropdown-left">
          <a
            id="navEventsItem"
            class="dropdown-item"
            [href]="onClickTab('events')"
            target="_blank"
          >
            <i class="pi pi-calendar-times mr-3"></i><b>Deadlines</b>
          </a>
          <a
            *ngIf="hasTechNewsJsAccess()"
            class="dropdown-item"
            [href]="onClickTab('search')"
          >
            <i class="pi pi-search mr-3"></i><b>Classic Search</b>
          </a>
          <a
            id="navListBuilderItem"
            *ngIf="hasTechNewsJsAccess()"
            class="dropdown-item"
            [href]="onClickTab('lists')"
          >
            <i class="pi pi-list mr-3"></i><b>Classic Lists</b>
          </a>
          <a
            id="navChartsItem"
            *ngIf="hasTechNewsJsAccess()"
            class="dropdown-item"
            [href]="onClickTab('charts')"
          >
            <i class="pi pi-chart-pie mr-3"></i><b>Classic Charts</b>
          </a>
          <a
            *ngIf="isAdmin()"
            id="navTopicsItem"
            class="dropdown-item"
            href="javascript:;"
            (click)="storeResetLvLGod('Topics')"
          >
            <i class="pi pi-hashtag mr-3"></i><b>Topics</b>
          </a>
        </div>
      </ng-template>
    </p-overlayPanel>
    <button
      id="navMoreItem"
      type="button"
      (click)="opMore.toggle($event)"
      class="nav-link waves-effect waves-dark nav-menu-toggle"
      aria-label="More"
      [attr.aria-expanded]="opMore.overlayVisible"
    >
      <i class="pi pi-ellipsis-h font-18 mr-2"></i>
      <span class="font-18 force-pointer" *ngIf="visibleLabels">More</span>
    </button>
  </li>

  <li class="nav-item" *ngIf="expireMessage">
    <div class="nav-link waves-effect waves-dark m-l-20">
      <span class="font-15 font-italic">{{
        visibleMassageSub ? expireMessage : ''
      }}</span>
      &nbsp;
      <a (click)="showSignMeUpDialog()" class="button signUp text-white"
        >Pricing / Sign up</a
      >
    </div>
  </li>
</ul>

<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<!-- Help, project button, and avatar together, left to right -->
<ul class="navbar-nav float-right align-items-center">
  <!-- ============================================================== -->
  <!-- Help menu -->
  <!-- ============================================================== -->
  <p-overlayPanel p-overlaypanel-help #opHelp>
    <ng-template pTemplate>
      <div class="dropdown-left">
        <a [href]="helpUrl()" target="_blank" class="dropdown-item">
          <i class="pi pi-question-circle mr-3"></i><b>Help Guide</b>
        </a>
        <button
          (click)="openReportMissingDataModal()"
          class="dropdown-item force-pointer"
          style="color: #5f676f"
        >
          <i class="pi pi-flag mr-3"></i><b>Report Missing Data</b>
        </button>
        <a
          href="mailto:support@technews.io"
          target="_blank"
          class="dropdown-item"
        >
          <i class="pi pi-envelope mr-3"></i><b>{{ supportEmail }}</b>
        </a>
      </div>
    </ng-template>
  </p-overlayPanel>
  <li class="nav-item">
    <a
      (click)="opHelp.toggle($event)"
      class="nav-link waves-effect waves-dark"
      tooltipPosition="bottom"
      ><i class="pi pi-question-circle font-18 mr-2"></i>
      <span class="font-18 force-pointer" *ngIf="visibleLabels">Help</span>
    </a>
  </li>
  <!-- Project selector button -->
  <li class="nav-item d-flex align-items-center" *ngIf="projects">
    <button
      id="projectBtn"
      pTooltip="Context Management"
      tooltipPosition="bottom"
      (click)="handleEditProject()"
      pButton
      pRipple
      type="button"
      class="p-button-rounded p-button-secondary p-button-text force-pointer"
      [style]="{ 'max-width': '200px' }"
    >
      <img
        *ngIf="showProjectLogo"
        [src]="projectLogo"
        (error)="onProjectLogoError()"
        class="project-button-logo"
        alt=""
      />
      <span class="p-button-label">{{ selectedProject?.label }}</span>
    </button>
  </li>
  <!-- User avatar + profile dropdown -->
  <li class="nav-item d-none d-lg-flex align-items-center">
    <p-overlayPanel
      #opProfile
      (onHide)="hideOverlayPanel()"
      styleClass="modern-profile-dropdown"
    >
      <ng-template pTemplate>
        <div class="profile-dropdown-container">
          <!-- USER INFO HEADER -->
          <div class="profile-header">
            <div class="profile-avatar" pTooltip="Account Settings">
              <img
                [src]="picture"
                onerror="this.src='assets/images/profile.png'"
                alt="user"
                class="rounded-circle"
              />
            </div>
            <div class="profile-info">
              <div class="profile-name">{{ name }}</div>
              <div class="profile-account" *ngIf="account !== name">
                {{ account }}
              </div>
              <div class="profile-masquerade" *ngIf="isMasquerading()">
                Masquerading
              </div>
              <div class="profile-role" *ngIf="isAdmin()">Admin</div>
            </div>
          </div>

          <div class="profile-menu-divider"></div>

          <!-- MENU ITEMS -->
          <div class="profile-menu">
            <a
              href="javascript:;"
              (click)="myAccount()"
              class="profile-dropdown-item"
              id="myAccountOpt"
            >
              <i class="pi pi-user"></i> <b>My Account</b>
            </a>
            <!-- Show this if they're already a customer in Stripe -->
            <a
              id="billingOpt"
              *ngIf="paymentsUrl()"
              [href]="paymentsUrl()"
              (click)="hideOverlayPanel()"
              class="profile-dropdown-item"
            >
              <i class="pi pi-money-bill"></i><b>Billing</b>
            </a>
            <!-- Show this if they're not yet a customer in Stripe -->
            <!--        <a-->
            <!--          id="subscriptionOpt"-->
            <!--          href="javascript:;"-->
            <!--          *ngIf="!paymentsUrl()"-->
            <!--          (click)="showSignMeUpDialog()"-->
            <!--          class="profile-dropdown-item"-->
            <!--        >-->
            <!--          <i class="pi pi-wallet"></i><b>Subscription</b>-->
            <!--        </a>-->
            <a
              href="javascript:;"
              (click)="logout()"
              class="profile-dropdown-item"
              id="logoutOpt"
            >
              <i class="pi pi-power-off"></i><b>Logout</b>
            </a>
          </div>
        </div>
      </ng-template>
    </p-overlayPanel>
    <div
      id="avatarBtn"
      (click)="toggleProfilePanel($event)"
      class="dropdowmnuser"
      pTooltip="Account Settings"
      tooltipPosition="bottom"
    >
      <a
        class="px-2"
        id="dropdownUser"
        style="display: flex; align-items: center"
      >
        <div class="avatar-badge-container">
          <img
            [src]="picture"
            onerror="this.src='assets/images/profile.png'"
            alt="user"
            class="rounded-circle avatar-image"
            width="36"
            height="36"
          />
          <span class="admin-badge" *ngIf="isAdmin()">Admin</span>
          <span class="masquerade-badge" *ngIf="isMasquerading()">Mask</span>
        </div>
      </a>
    </div>
  </li>
</ul>
